enum SelfServiceStatus {
  SENT = 'SENT',
  ANSWERED = 'ANSWERED',
  IN_PROGRESS = 'IN_PROGRESS',
}

export default SelfServiceStatus;
